import { useSearchParams } from 'react-router-dom';

type TParam = {
  key: string;
};

export const useParam = (param: TParam) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setParam = (value: string) => {
    setSearchParams(
      (params) => {
        params.set(param.key, value);
        return params;
      },
      { replace: true },
    );
  };
  const removeParam = () => {
    setSearchParams(
      (params) => {
        params.delete(param.key);
        return params;
      },
      { replace: true },
    );
  };

  return { value: searchParams.get(param.key), setParam, removeParam };
};
